<mat-form-field appearance="fill" (click)="picker.open()" style="margin-top: -23px;"
    [ngClass]="{'hide': hideDatePicker }" [ngStyle]="disablePointerEvent === true && {
        'pointer-events':'none'}" >
    <input [(ngModel)]="inputDate" class="customFont" matInput [matDatepicker]="picker" [max]="maxDate" [min]="minDate"
        (dateChange)="updateDate()" />
    <span matSuffix *ngIf="isCellValue" (click)="clearText()"><i class="fas fa-times"></i></span>
    <mat-datepicker [startAt]="startDate" (closed)="datePickerClosed()" #picker></mat-datepicker>
</mat-form-field>

<mat-form-field appearance="fill"
    *ngIf="inputDate && (inputDate.toString().indexOf('(Missing Required Data)') > -1 || inputDate.toString().indexOf('Data Error') > -1 || inputDate.toString().indexOf('(MRN_Duplicate Error)') > -1)"
    (click)="hideDatePicker = false;picker.open()" style="margin-top: -18px;">
    <span matSuffix *ngIf="isCellValue" (click)="clearText()"><i class="fas fa-times"></i></span>
    <input class="customFont" type="text" [(ngModel)]="inputDate" matInput />
</mat-form-field>